/** Vibecode authoring notes for `flex` nodes (empty = omit from LLM bundle). */
export const FLEX_VIBECODE = [
  '`flex`: `variant` compact|default|loose; `gap` overrides preset.',
  'Side-by-side cards: `{ direction:"row", wrap:true, alignItems:"start" }`.',
].join('\n');
